import React from 'react';
import { Wrap, EasyActions, EasyWin, Loader } from '../../components/index';
import * as _ from 'lodash';
import { useResponsivity } from '../../helpers/helpers';
import { Row, Col } from 'react-styled-flexboxgrid';
import { useTranslation } from 'react-i18next';
import store from 'store2';
interface BathroomTapProps {
  challenges: any;
  listLocation: any;
  getChallengeCategory: Function;
  completeChallenge: Function;
  completeTask: any;
  generalData: Function;
  getOffers: Function;
}

const BathroomTap: React.FC<BathroomTapProps> = (props) => {
  const {
    challenges,
    getChallengeCategory,
    completeChallenge,
    completeTask,
    generalData,
    getOffers,
  } = props;
  const getRoomId = store('property');
  const data = _.get(challenges, 'data.challenges');
  const offers = _.get(challenges, 'offers.data.challenges');

  const isMobile = useResponsivity();
  const plumberVisit = _.find(offers, function (o) {
    return o.tag.includes('PLUMBER_VISIT');
  });
  const [t] = useTranslation('common');
  const loadingChallenges = _.get(challenges, 'status.loading');

  const { error, loading, done } = _.get(completeTask, 'status');
  React.useEffect(() => {
    getChallengeCategory(getRoomId, 'bathroom-tap');
    getOffers(getRoomId);
  }, [getRoomId]);
  const pageArray = [
    {
      id: 265,
      title: 'Washroom basin taps',
      icon: 'faucet',
      description:
        'Washroom basin taps can be huge water wasters, with high flow rates and taps left running when not in use – both of which can significantly impact energy bills.',
      easyWins: [
        {
          title: 'Engage staff',
          size: 'half',
          hasLogo: false,
          description: [
            'Print off the poster and place beside the basin taps to remind staff to turn off the tap while washing hands. This poster will help reduce cold & hot water use in your business by as much as 30%.',
          ],
          buttonText: 'Download PDF',
          buttonIcon: 'download',
          linkType: 'button',
          buttonPath:
            'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/posters/cheetah.pdf',
          poster:
            'https://cdn.getwaterfit.co.uk/static/files/images/gwf-business/posters/cheetah.png',
        },
        {
          title: 'Tell us your achievements',
          description: [
            'Confirm which actions you’ve completed to see how much water and money we think you’ll save.',
          ],
          size: 'half',
          theme: 'blue',
          hasLogo: false,
          isEasyAction: true,
        },
        {
          title: 'Plumber Tips',
          size: 'half',
          icon: 'faucet',
          hasLogo: false,
          description: [
            'Make sure your washroom percussion taps operate for around 10 seconds each time they are pressed. Percussion taps that run for longer often pour out water when staff have already finished washing their hands. Remember that wasted hot water will impact energy bills, too.',
            'Your Facilities Manager or Plumber will be able to adjust the timing, if required.',
          ],
        },
        {
          title: 'Fix a leak',
          size: 'half',
          hasLogo: false,
          icon: 'fixLeak',
          buttonText:
            plumberVisit !== undefined
              ? 'Book a Free plumber visit'
              : 'Find a plumber',
          linkType:
            plumberVisit !== undefined ? 'internalLink' : 'externalLink',
          buttonPath:
            plumberVisit !== undefined
              ? '/actions'
              : 'https://www.watersafe.org.uk',
          buttonIcon: null,

          description: [
            'Taps with a constant drip could be wasting as much as 50 litres every day, even at weekends when staff are at home – which will impact your water bill.',
          ],
        },

        {
          title: 'Smart products',
          theme: 'green',
          size: 'full',
          hasLogo: true,
          icon: null,
          buttonText: 'Find water efficient taps',
          linkType: 'externalLink',
          buttonPath:
            'https://uk.getwatersmart.com/products?category=CommercialWashroomTaps',
          description: [
            'Reduce cold & hot water use by switching to percussion or sensor taps.',
            'Percussion taps produce a timed flow of water i.e. for around 10 seconds before the tap turns off automatically. Sensor taps only operate when a staff member is directly in front of the wash basin, often when their hands are directly beneath the tap spout end.',
            'Unlike pillar and mixer taps, which require the user to manually turn off the tap, percussion and sensor taps provide only the required amount of water for washing hands. They also minimise the risk of taps being left on overnight or at weekends.',
          ],
        },
      ],
    },
  ];

  const getChallenges = () => {
    return _.map(data, (el, index) => {
      const title = _.get(el, 'title');
      const description = _.get(el, 'description');
      const buttonText = _.get(el, 'buttonText');
      const type = _.get(el, 'internalType');
      const buttonPath = _.get(el, 'buttonPath');
      const energySaving = _.get(el, 'energy_saving');
      const carbonSaving = _.get(el, 'carbon_saving');
      const waterSaving = _.get(el, 'water_saving');
      const exType = _.get(el, 'type');
      return (
        <Col xs={12} sm={12} md={12} key={index}>
          <EasyActions
            isDesktop={!isMobile}
            icon={_.get(el, 'icon')}
            id={_.get(el, 'id')}
            title={`${t(title)}`}
            description={`${t(description)}`}
            buttonText={`${t(buttonText)}`}
            buttonPath={buttonPath}
            popup={type === 'direct-redirect' ? false : true}
            renderComplete={() => {
              completeChallenge(getRoomId, _.get(el, 'id'));
              setTimeout(() => {
                getChallengeCategory(getRoomId, 'bathroom-tap');
                generalData();
              }, 1000);
            }}
            isLoading={loading}
            completed={done}
            energySaving={energySaving}
            carbonSaving={carbonSaving}
            waterSaving={waterSaving}
            type={exType}
          />
        </Col>
      );
    });
  };

  if (loadingChallenges) {
    return (
      <Wrap>
        <Loader />
      </Wrap>
    );
  }

  return (
    <Wrap>
      <EasyWin data={pageArray}>
        <Row style={{ marginTop: '16px' }}>{getChallenges()}</Row>
      </EasyWin>
    </Wrap>
  );
};

export default BathroomTap;
